module.exports = __webpack_public_path__ + "static/media/hyundai-vest.4b652c7c.svg";